import React from 'react';

import { Modal } from '~components';
import { Form as WizardForm } from '~components/wizard-form';

import steps from '~support-at-home/forms/co-contributions/new';

interface ComponentProps {
  isOpen: boolean;
  setIsOpen: (toggle: boolean) => void;
}

const CoContributionsWizard: React.FC<ComponentProps> = ({ isOpen, setIsOpen }) => {
  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      header="New Co-Contribution"
      headerClassName="header"
      className="co-contribution-wizard-modal"
      includeFooter={false}
      unmountOnClose
    >
      <WizardForm steps={steps} onComplete={() => setIsOpen(false)} submitCaption="Close" />
    </Modal>
  );
};

export default CoContributionsWizard;
